module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_gefährliche_Stoffe.96bf451a.svg";